import React from 'react'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { PhotoHero } from '@revelrygroup/components'
import { API } from '../revelry_api'
import { FuneralHome } from '../types'
import { FuneralHomeFooter } from '../components/FuneralHomeFooter'
import { FuneralHomeModel } from '../components/models/FuneralHomeModel'
import Layout from '../components/Layout'
import SocialFeature from '../components/SocialFeature'
import { Testimonials } from '../components/Testimonials'
import ArlingtonSection from '../components/VeteranServices/ArlingtonSection'
import CoordinatedArrivalSection from '../components/VeteranServices/CoordinatedArrivalSection'
import ServiceListSection from '../components/VeteranServices/ServiceListSection'
import CtaBanner from '../components/VeteranServices/CtaBanner'
import VeteranContactSection from '../components/VeteranServices/VeteranContactSection'
import SupportBeyondSection from '../components/VeteranServices/SupportBeyondSection'
import DmvSectionTwo from '../components/VeteranServices/DmvSectionTwo'
import VeteranServicesIntro from '../components/VeteranServices/VeteranServicesIntro'
import EventTrackingModel from '../components/models/EventTrackingModel'

interface Props {
  funeralHome: FuneralHome | null
}

const VeteranServicesPage: React.FC<Props> = ({ funeralHome }) => {
  return (
    <>
      <Head>
        <title>
          Veteran Services - {funeralHome?.name} - {FuneralHomeModel.headTagLocation(funeralHome)}
        </title>

        <meta
          name="description"
          key="description"
          content={`${funeralHome?.name} provides veteran burial services at Arlington National Cemetery and full veteran funeral services in the DC, Maryland, and Virginia area. Serving those who served with dignity and care.`}
        />
      </Head>

      <Layout>
        <PhotoHero>Veteran Services</PhotoHero>
        <VeteranServicesIntro />

        <div className="height-100">
          <main>
            <ArlingtonSection />
            <CoordinatedArrivalSection />
            <SupportBeyondSection />
            <ServiceListSection />
            <CtaBanner
              headline="Connect with a Funeral Director for"
              subheadline="ARLINGTON NATIONAL CEMETERY SERVICES"
              backgroundImage="/veteran-services/arlington-cherry-blossoms.jpg"
              onClick={() => EventTrackingModel.trackArlingtonServicesButtonClick('cta_banner')}
            />

            <DmvSectionTwo />

            <CtaBanner
              headline="Connect with a Funeral Director for"
              subheadline="FULL VETERAN SERVICES IN THE DMV"
              backgroundImage="/veteran-services/flag-folding.jpg"
              onClick={() =>
                EventTrackingModel.trackGeneralVeteranServicesButtonClick('cta_banner')
              }
            />

            <VeteranContactSection />

            <SocialFeature />

            <Testimonials />
          </main>

          <FuneralHomeFooter />
        </div>
      </Layout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async () => {
  try {
    const funeralHome = await API.funeralHomes.load()

    return { props: { funeralHome } }
  } catch (e) {
    return { props: { funeralHome: null } }
  }
}

export default VeteranServicesPage
